// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Marco Serrano

// Last Modified: 2025-11-19
// Modified By: Marco Serrano

// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { forwardRef } from "react";
import { CSVLink } from "react-csv";

// Button that downloads a CSV file. we pass in a ref through the forwardRef wrapper around this inner component.
// The reason for this is there is an underlying anchor tag that we need to be able to have access to in order to
// manually download a CSV file without actually clicking on the component
function CsvDownloadInnerButton(
  props: Props,
  ref: React.Ref<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>
): Component {
  return (
    <CSVLink
      ref={ref}
      onClick={props.onClick}
      data={props.data}
      className={`${props.className}`}
      filename={props.fileName}
      enclosingCharacter=""
    >
      {props.children}
    </CSVLink>
  );
}

// Wrapping CsvDownloadInnerButton here for with a ref to CSVLink -> HTMLAnchorElement -> {link: HTMLAnchorElement} as
// this is how react-csv has it setup
const CsvDownloadButton = forwardRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }, Props>(
  CsvDownloadInnerButton
);

interface Props {
  fileName: string;
  className?: string;
  data: string[][];
  children: React.ReactNode;
  onClick?: () => void | boolean;
}

export default CsvDownloadButton;
